// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ptrr","footer":"styles_footer__2CnGd","passCodeTooltip":"styles_passCodeTooltip__zAr2_"};